export enum WellnessProgramActivity {
    Incomplete = "Incomplete",
    PartiallyComplete = "PartiallyComplete",
    Complete = "Complete",
}